import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeTwoComponent } from './components/pages/home-two/home-two.component';
import {ContactComponent} from './components/common/contact/contact.component';
import {AboutComponent} from './components/common/about/about.component';
import {ItConsultingComponent} from './components/common/it-consulting/it-consulting.component';
import {RpaComponent} from './components/common/rpa/rpa.component';
import {ProjectManagementComponent} from './components/common/project-management/project-management.component';
import {ItServicesComponent} from './components/common/it-services/it-services.component';
import {InitiativesComponent } from './components/common/initiatives/initiatives.component'
import {SolutionsComponent} from "./components/common/solutions/solutions.component";
import { NotFoundComponent }  from './components/pages/not-found/not-found.component';
import { Solution1Component } from './components/common/solution1/solution1.component';
import { Solution2Component } from './components/common/solution2/solution2.component';

const routes: Routes = [
    {path: '', component: HomeTwoComponent},
    {path: 'about-us', component: AboutComponent},
    {path: 'products', component: SolutionsComponent},
    
    { path: 'products/solution1', component: Solution1Component },
    { path: 'products/solution2', component: Solution2Component },
    {path: 'contact', component: ContactComponent},
    {path: 'it-consulting', component: ItConsultingComponent},
    {path: 'rpa', component: RpaComponent},
    {path: 'project-management', component: ProjectManagementComponent},
    {path: 'it-services', component: ItServicesComponent},
    {path: 'initiatives', component: InitiativesComponent},

    /* {path: 'home-three', component: HomeThreeComponent},*/ // Not used in the current version
    /*{path: 'blog', component: BlogPageComponent},*/ // Not used in the current version
    /*{path: 'single-blog', component: BlogDetailsComponent},*/ // Not used in the current version
    /* {path: 'home-one', component: HomeOneComponent},*/ // Not used in the current version

    { path: '404', component: NotFoundComponent },
    { path: '**',  redirectTo: '/404', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
            useHash: false,
            relativeLinkResolution: 'legacy'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
